var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 35,
    viewBox: "0 0 32 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.91667 30.3542H9.79167V18.6042H21.5417V30.3542H27.4167V12.7292L15.6667 3.91667L3.91667 12.7292V30.3542ZM3.91667 34.2708C2.83959 34.2708 1.91721 33.887 1.14954 33.1193C0.381878 32.3517 -0.00130223 31.4299 3.32485e-06 30.3542V12.7292C3.32485e-06 12.109 0.139045 11.5215 0.417128 10.9667C0.695211 10.4118 1.07839 9.95486 1.56667 9.59583L13.3167 0.783333C13.6757 0.522222 14.051 0.326389 14.4427 0.195833C14.8344 0.0652776 15.2424 0 15.6667 0C16.091 0 16.499 0.0652776 16.8906 0.195833C17.2823 0.326389 17.6576 0.522222 18.0167 0.783333L29.7667 9.59583C30.2563 9.95486 30.6401 10.4118 30.9182 10.9667C31.1963 11.5215 31.3346 12.109 31.3333 12.7292V30.3542C31.3333 31.4312 30.9495 32.3536 30.1818 33.1213C29.4142 33.889 28.4924 34.2721 27.4167 34.2708H17.625V22.5208H13.7083V34.2708H3.91667Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon);
export default __webpack_public_path__ + "static/media/homeicon.3b596980786a4201564d9ae0c822df20.svg";
export { ForwardRef as ReactComponent };